// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    PM_USERS_CREATE_USER_REQUEST,
    PM_USERS_SEARCH_ROLES_REQUEST,
    PM_USERS_UPDATE_USER_REQUEST,
    PM_USERS_GET_USER_REQUEST,
} from 'Redux/actionTypes';

// Actions
import {
    usersSearchRolesResult,
    createPMUserResult,
    pmUsersGetUserResult,
    updatePMUserResult,
} from 'Redux/actions';

// Helpers
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* createUsers({ payload }) {
    try {
        let QUERY = `
            mutation createUser ($firstName: String!, $lastName: String, $username: String!, $email: String!, $roles: [Int], $isRestricted: Boolean, $dealerIds: [Int], $dealerId: Int) {
                result: createUser (firstName: $firstName, lastName: $lastName, username: $username, email: $email, roles: $roles, isRestricted: $isRestricted, dealerIds: $dealerIds, dealerId: $dealerId) {
                    id
                    firstName
                    lastName
                    username
                    email
                    status
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        if (data) yield put(createPMUserResult(data?.result))
        else yield put(createPMUserResult({ error: true }))

    } catch (exc) {
        ExceptionManager(
            exc,
            'Modules/pmUsers/.components/createEditUser/redux/saga',
            'createUsers'
        );
        yield put(createPMUserResult({ error: true, errorMessage: exc?.error }))
    }
}

function* updateUser({ payload }) {
    try {
        let QUERY = `
            mutation updateUser ($id: Int!, $firstName: String, $lastName: String, $roleIds: [Int], $isRestricted: Boolean, $dealerIds: [Int], $dealerId: Int) {
                result: updateUser (id: $id, firstName: $firstName, lastName: $lastName, roleIds: $roleIds, isRestricted: $isRestricted, dealerIds: $dealerIds, dealerId: $dealerId) {
                    id
                    firstName
                    lastName
                    username
                    email
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if(data?.result) yield put(updatePMUserResult(data?.result))
        else yield put(updatePMUserResult({ error: true }))
    } catch (exc) {
        yield put(updatePMUserResult({ error: true }))
        ExceptionManager(
            exc,
            'Modules/pmUsers/.components/createEditUser/redux/saga',
            'updateUser'
        );
    }
}

function* searchRoles({ payload }) {
    try {
        let QUERY = `
            query searchRoles ($conditions: [RoleSearchInput], $sort: [RoleSortInput], $limit: Int, $offset: Int) {
                result: searchRoles (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        projectId
                        name
                    }
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["projectId"],
                    terms: ["PM"],
                    exact: true
                },
                limit: 1000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            const { items } = data?.result
            yield put(usersSearchRolesResult(items))
        } else {
            yield put(usersSearchRolesResult([]))
        }

    } catch (exc) {
        ExceptionManager(
            exc,
            'Modules/pmUsers/.components/createEditUser/redux/saga.js',
            'searchRoles'
        );
        yield put(usersSearchRolesResult([]))
    }
}

function* getUser({ payload }) {
    try {
        let QUERY = `
            query getUser ($id: Int!) {
                result: getUser (id: $id) {
                    id
                    firstName
                    lastName
                    username
                    email
                    roles {
                        id
                        projectId
                        name
                    }
                    isRestricted
                    dealerIds
                    dealerId
                }
            }
        `;
        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            yield put(pmUsersGetUserResult(data?.result))
        }
    } catch (exc) {
        yield put(pmUsersGetUserResult({ error: true }))
        ExceptionManager(
            exc,
            'Modules/pmUsers/.components/createEditUser/redux/saga',
            'getUser'
        );
    }
}

function* watchMethods() {
    yield takeEvery(PM_USERS_CREATE_USER_REQUEST, createUsers);
    yield takeEvery(PM_USERS_SEARCH_ROLES_REQUEST, searchRoles);
    yield takeEvery(PM_USERS_GET_USER_REQUEST, getUser);
    yield takeEvery(PM_USERS_UPDATE_USER_REQUEST, updateUser);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}